module.exports = __webpack_public_path__ + "img/gallery-image-4.ec8c0189.jpg";